export const DEPLOYENVIRONMENT = '';
// export const FILE_PORT = '16443';
// export const API_PORT = '5443';
// export const PRESENCE_PORT = '3443';
export const FILE_PORT = '443';
export const API_PORT = '443';
export const PRESENCE_PORT = '443';
